export default {
  SINGLE_VIDEO: 'SINGLE_VIDEO',
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  FRONT: 'FRONT',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
} as const
